/** How the log stream's connection state is displayed. */
export type StreamPhase = "connecting" | "open" | "dropped" | "idle";

/**
 * The phase to show after the stream reports an error.
 *
 * Two cases, and the difference matters to the reader of the badge:
 *
 * - A **refusal** (401/403) is terminal. The stream deliberately does not
 *   reconnect after one, so leaving the badge on "connecting" would promise a
 *   recovery that is never coming.
 * - Anything else is transient and will be retried, so it only counts as
 *   "dropped" if the stream had got as far as being open. A failure while
 *   still connecting keeps the connecting phase.
 */
export function phaseAfterError(
  previous: StreamPhase,
  status?: number,
): StreamPhase {
  if (status === 401 || status === 403) return "dropped";
  return previous === "open" ? "dropped" : previous;
}
